module.exports = __webpack_public_path__ + "media/icons/black-check-55317c87.svg";